<template>
  <v-container class="pa-0 bg-primary">
    <v-container-restricted
      class="pa-5 pa-sm-7 pa-md-10"
      style="max-width: var(--homepage-max-width) !important"
    >
      <v-row no-gutters style="gap: 30px" justify="space-between">
        <v-col style="max-width: max-content; min-width: max-content">
          <p class="text-subtitle-1 mb-2">Info</p>
          <NuxtLink to="/" class="text-decoration-none text-white">
            <p class="text-subtitle-2 font-weight-light mb-2">Products</p>
          </NuxtLink>
          <NuxtLink to="/" class="text-decoration-none text-white">
            <p class="text-subtitle-2 font-weight-light mb-2">Case Studies</p>
          </NuxtLink>
          <NuxtLink to="/" class="text-decoration-none text-white">
            <p class="text-subtitle-2 font-weight-light mb-2">FAQ</p>
          </NuxtLink>
          <NuxtLink to="/" class="text-decoration-none text-white">
            <p class="text-subtitle-2 font-weight-light mb-2">Status</p>
          </NuxtLink>
        </v-col>
        <v-col style="max-width: max-content; min-width: max-content">
          <p class="text-subtitle-1 mb-2">Company</p>
          <NuxtLink to="/" class="text-decoration-none text-white">
            <p class="text-subtitle-2 font-weight-light mb-2">About us</p>
          </NuxtLink>
          <NuxtLink to="/" class="text-decoration-none text-white">
            <p class="text-subtitle-2 font-weight-light mb-2">
              Terms of Service
            </p>
          </NuxtLink>
          <NuxtLink to="/" class="text-decoration-none text-white">
            <p class="text-subtitle-2 font-weight-light mb-2">Privacy</p>
          </NuxtLink>
          <NuxtLink to="/" class="text-decoration-none text-white">
            <p class="text-subtitle-2 font-weight-light mb-2">Sustainability</p>
          </NuxtLink>
        </v-col>
        <v-col style="max-width: max-content; min-width: max-content">
          <p class="text-subtitle-1 mb-2">Resources</p>
          <NuxtLink to="/" class="text-decoration-none text-white">
            <p class="text-subtitle-2 font-weight-light mb-2">How it Works</p>
          </NuxtLink>
          <NuxtLink to="/" class="text-decoration-none text-white">
            <p class="text-subtitle-2 font-weight-light mb-2">Blog</p>
          </NuxtLink>
          <NuxtLink to="/" class="text-decoration-none text-white">
            <p class="text-subtitle-2 font-weight-light mb-2">Tools</p>
          </NuxtLink>
        </v-col>
        <v-col style="max-width: max-content; min-width: max-content">
          <p class="text-subtitle-1 mb-2">Follow us</p>
          <NuxtLink to="/" class="text-decoration-none text-white">
            <v-row style="gap: 10px" no-gutters class="flex-no-wrap mb-2">
              <v-icon icon="mdi-facebook"></v-icon>
              <p class="text-subtitle-2">Facebook</p></v-row
            >
          </NuxtLink>
          <NuxtLink to="/" class="text-decoration-none text-white">
            <v-row style="gap: 10px" no-gutters class="flex-no-wrap mb-2">
              <v-icon icon="mdi-instagram"></v-icon>
              <p class="text-subtitle-2">Instagram</p></v-row
            >
          </NuxtLink>
          <NuxtLink to="/" class="text-decoration-none text-white">
            <v-row style="gap: 10px" no-gutters class="flex-no-wrap mb-2">
              <v-icon icon="mdi-twitter"></v-icon>
              <p class="text-subtitle-2">Twitter</p></v-row
            >
          </NuxtLink>
          <NuxtLink to="/" class="text-decoration-none text-white">
            <v-row style="gap: 10px" no-gutters class="flex-no-wrap mb-2">
              <v-icon icon="mdi-linkedin"></v-icon>
              <p class="text-subtitle-2">Linked In</p></v-row
            >
          </NuxtLink>
        </v-col>
        <v-col style="max-width: 300px">
          <p class="text-subtitle-1 mb-2">Subscribe to our news letter</p>
          <v-row no-gutters>
            <v-text-field
              style="min-width: 150px"
              placeholder="Email"
              density="compact"
              bg-color="background"
            ></v-text-field>
            <v-btn density="compact" class="text-subtitle-2 px-2 mx-1 mx-sm-2"
              >Subscribe</v-btn
            >
          </v-row>
          <v-row class="flex-nowrap ga-2 mb-2" no-gutters>
            <v-icon icon="mdi-email"></v-icon>
            <a
              class="text-subtitle-2 text-white"
              href="mailto:support@techali.co"
              >support@techali.co</a
            >
          </v-row>
          <v-row class="flex-nowrap ga-2" no-gutters>
            <v-icon icon="mdi-map"></v-icon>
            <p class="text-subtitle-2 text-white">
              30 N GOULD STE 42859 SHERIDAN, WYOMING 82801
            </p>
          </v-row>
        </v-col>
      </v-row>
      <p class="text-caption text-center text-light-grey mt-3">
        All rights reserved &copy; TechAl
      </p>
    </v-container-restricted>
  </v-container>
</template>
